import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

import { FS } from "@plannel/utils/font-util";

/**
 * Autocomplete 목록을 묶는 구분 줄.
 *
 * <p><b>규칙: 목록에 구분을 넣으면 그 줄은 색을 입힌다.</b> MUI 기본 그룹 라벨은 회색 잔글씨라
 * 항목들 사이에 묻혀서, 구분을 넣어 놓고도 어디서 끊기는지 보이지 않는다. 구분을 넣는 이유가
 * "이 아래부터는 성격이 다른 것들" 을 알리는 것이므로, 그 줄이 안 보이면 넣은 의미가 없다.
 *
 * <p>모든 그룹이 같은 색이다. 그룹마다 다른 색을 주면 색이 무언가를 뜻하는 것처럼 읽히는데,
 * 여기서 색은 "이건 항목이 아니라 머리글" 이라는 표시일 뿐이다.
 *
 * <p>sticky 라 목록을 굴려도 지금 보고 있는 묶음이 무엇인지 계속 보인다.
 *
 * @example
 * <Autocomplete groupBy={...} renderGroup={renderAutocompleteGroup} ... />
 */
/**
 * 구분 줄의 규격.
 *
 * <p>Autocomplete 말고 <b>Select 의 ListSubheader</b> 등 다른 목록에도 그대로 얹는다 —
 * 같은 규칙인데 화면마다 다르게 보이면 규칙이 아니다.
 */
export const LIST_GROUP_HEADER_SX = {
  position: "sticky",
  top: -4,
  zIndex: 1,
  px: 1.5,
  py: 0.5,
  lineHeight: 1.8,
  fontSize: FS.CAPTION,
  fontWeight: 700,
  letterSpacing: 0.4,
  color: "primary.main",
  // 배경까지 옅게 깔아야 머리글로 읽힌다 — 글자색만 바꾸면 그냥 파란 항목처럼 보인다
  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
  borderBottom: 1,
  borderColor: (theme) => alpha(theme.palette.primary.main, 0.2)
};

export const renderAutocompleteGroup = (params) => (
  <li key={params.key}>
    <Box sx={LIST_GROUP_HEADER_SX}>
      <Typography sx={{ fontSize: "inherit", fontWeight: "inherit", letterSpacing: "inherit", color: "inherit" }}>
        {params.group}
      </Typography>
    </Box>
    <Box component="ul" sx={{ p: 0 }}>
      {params.children}
    </Box>
  </li>
);

export default renderAutocompleteGroup;
